/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../ClientApp/app/pages/login/login.component';
import * as i2 from '@angular/router';
import * as i3 from '../../../../../ClientApp/app/_shared/services/msal.service';
import * as i4 from '../../../../../ClientApp/app/_shared/services/monitoring.service';
const styles_LoginComponent:any[] = ([] as any[]);
export const RenderType_LoginComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_LoginComponent,data:{}});
export function View_LoginComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),['Omleiding naar inlogpagina volgt...']))],(null as any),
      (null as any));
}
export function View_LoginComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-login',([] as any[]),
      (null as any),(null as any),(null as any),View_LoginComponent_0,RenderType_LoginComponent)),
      i0.ɵdid(114688,(null as any),0,i1.LoginComponent,[i2.ActivatedRoute,i2.Router,
          i3.MsalService,i4.MonitoringService],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LoginComponentNgFactory:i0.ComponentFactory<i1.LoginComponent> = i0.ɵccf('app-login',
    i1.LoginComponent,View_LoginComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9DbGllbnRBcHAvYXBwL3BhZ2VzL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvQ2xpZW50QXBwL2FwcC9wYWdlcy9sb2dpbi9sb2dpbi5jb21wb25lbnQudHMiLCJuZzovLy9hcHAvQ2xpZW50QXBwL2FwcC9wYWdlcy9sb2dpbi9sb2dpbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9DbGllbnRBcHAvYXBwL3BhZ2VzL2xvZ2luL2xvZ2luLmNvbXBvbmVudC50cy5Mb2dpbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxoMz5PbWxlaWRpbmcgbmFhciBpbmxvZ3BhZ2luYSB2b2xndC4uLjwvaDM+IiwiPGFwcC1sb2dpbj48L2FwcC1sb2dpbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBLHdFQUFJO2FBQUE7Ozs7b0JDQUo7TUFBQTthQUFBOzZDQUFBOztJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./$$_gendir/ClientApp/app/pages/login/login.component.ngfactory.ts